import { render } from "./Progress.vue?vue&type=template&id=126330ba&ts=true"
import script from "./Progress.vue?vue&type=script&lang=ts"
export * from "./Progress.vue?vue&type=script&lang=ts"

import "./Progress.vue?vue&type=style&index=0&id=126330ba&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__